module.exports = __webpack_public_path__ + "static/media/cate-indus.0838c8fb.png";